/**
 * @Author: DJ
 * @Date:   2021-08-27 09:55:18
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-08-27 16:19:50
 */

 import http from '@/assets/api/http';

 // 健康证审核-查询列表
 export async function jkzList(params){
     return http('/?cmd=com.xqxc.api.pig.mis.biz.rider.HealthCertificateAuditMisService.list',params,'POST');
 }
 
 
 // 健康证审核-详情
 export async function jkzDetail(params){
     return http('/?cmd=com.xqxc.api.pig.mis.biz.rider.HealthCertificateAuditMisService.detail',params,'POST');
 }

  // 健康证审核-审核
  export async function jkzAudit(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.rider.HealthCertificateAuditMisService.audit',params,'POST');
}

 // 健康证图片详情
 export async function jkzPicDetail(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.rider.HealthCertificateAuditMisService.getPicDetail',params,'POST');
}

 // 骑士状态
 export async function getEnum(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum',params,'POST');
}

 // 骑士详情
 export async function riderDetail(params){
    return http('/?cmd=com.xqxc.api.pig.mis.biz.account.RiderAccountMisService.riderDetail',params,'POST');
}